// src/App.js

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PostList from "./components/PostList";
import PostDetail from "./components/PostDetail";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/blog/:postId" element={<PostDetail />} />
                <Route path="/blog" element={<PostList />} />
            </Routes>
        </Router>
    );
}

export default App;
